//import styles
import "./scss/app.scss"

//import jQuery scripts
try {
    window.$ = window.jQuery = require('jquery')
} catch (e) {}

require('./js/jquery/gallery')
require('./js/jquery/floors')
require('./js/jquery/navigation-button')
require('./js/jquery/header-scroll')
require('./js/jquery/schedule-timeline')
require('./js/jquery/fit-text')
require('./js/jquery/reveal')
require('./js/jquery/intro-slides')
require('./js/jquery/map')
require('./js/jquery/location-map')
require('./js/jquery/pannellum')
require('./js/jquery/vr-tour')
require('./js/jquery/cf7-toast')